// ZOD
import * as z from 'zod';
import { LandingSlugType, LandingSlugZod, LandingType, LandingZod } from '@/views/Landing/LandingType';

// Strapi
import { blocks, seo } from '@/services/strapiPopulate';
import { fetchStrapiContentWithBlocks } from '@/services/blocks/fetchStrapiContentWithBlocks';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getLanding = async (slug: string): Promise<LandingType> =>
  fetchStrapiContentWithBlocks(`/api/landings/${slug}`, LandingZod, { blocks, seo }, 'Landing Page');

export const getLandings = async (): Promise<Array<LandingSlugType>> => {
  const pageSize = 10;
  const response = await client.get('/api/landings', {
    params: {
      fields: ['slug'],
      populate: {
        seo,
      },
      pagination: {
        page: 1,
        pageSize,
      },
    },
  });

  const totalPages = response.data?.meta?.pagination.pageCount || 1;
  const allData = [...(response.data?.data ?? [])];

  try {
    if (totalPages > 1) {
      const pagePromises = Array.from({ length: totalPages - 1 }, (_, i) =>
        client.get('/api/landings', {
          params: {
            fields: ['slug'],
            populate: {
              seo,
            },
            pagination: { page: i + 2, pageSize },
          },
        }),
      );
      const results = await Promise.all(pagePromises);
      results.forEach((r) => allData.push(...(r.data?.data || [])));
    }

    return z.array(LandingSlugZod).parseAsync(allData);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Landings structure:\n${formatZodError(error, allData)}`);
    }
    throw error;
  }
};
